<template>
  <div class="comment-collapse-card">
    <div class="collapse-item">
      <div
        class="collapse-title"
        @click="collapseToggle()"
      >
        <p class="comment-title">
          {{ $t(title) }}
        </p>
        <div class="title-right">
          <p v-if="date">
            {{ $t('更新日期') }}<span>{{ dateFormat(date) }}</span>
          </p>
          <i
            v-if="collapseActive"
            class="icon-unfold-less"
          />
          <i
            v-else
            class="icon-unfold-more"
          />
        </div>
      </div>
      <slide-up-down
        :active="collapseActive"
        :duration="300"
      >
        <div
          v-if="collapseActive"
          class="collapse-content"
        >
          <div class="icons-group">
            <slot name="law-icons" />
          </div>
          <p class="comment-collapse-card_text">
            {{ value ? value.ll_comment:'' }}
          </p>
          <slot name="rwo-cards" />
          <slot name="card-lists" />
        </div>
      </slide-up-down>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommentCollapseCard",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default() {
        return this.$t("ESGoal評析");
      },
    },
    date: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    collapseActive: false,
  }),
  mounted() {},
  methods: {
    collapseToggle() {
      this.collapseActive = !this.collapseActive;
    },
    dateFormat(time) {
      if (!time) return;
      return this.$moment(time).format("YYYY-MM-DD");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/comment-collapse-card";
</style>